import { type Product } from '@/services/products/types';
import { Price, type PriceLayout, type PriceSize } from '@/components/Price/Price';

export default function ProductPrice({
  layout = 'inline',
  priceToPayStyle = 'headingMedium',
  product,
}: {
  product: Product;
  priceToPayStyle?: PriceSize;
  layout?: PriceLayout;
}) {
  const { discount, formattedPrice, formattedUnitPrice, isPromo } = product;
  const isPromotional = isPromo && discount?.type !== 'cart';
  const formattedDiscountPrice = discount?.pricePerUnit?.discountedPrice?.formatted;
  return (
    <Price
      formattedPrice={formattedDiscountPrice ?? formattedPrice}
      formattedUnitPrice={formattedUnitPrice}
      isPromotional={isPromotional}
      layout={layout}
      priceToPayStyle={priceToPayStyle}
    />
  );
}
